<template>
<div>
  <section class="content-header">
    <h1>
      卡密查询
      <small>快速查询工具</small>
    </h1>
    <ol class="breadcrumb">
      <li><a href="#/"><i class="fa fa-dashboard"></i> Home</a></li>
      <li><a href="#/operateDetails/operateDetails">快速查询工具</a></li>
      <li class="active">卡密查询</li>
    </ol>
  </section>

  <section class="content">
    <el-card class="box-card" body-style="padding-bottom:0px">
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="cards" placeholder="请输入16位卡密号，多个卡号必须用逗号或空格分开（卡号1,卡号2,...）" clearable style="width: 470px"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="query">查询</el-button>
				</el-form-item>
			</el-form>
    </el-card>

    <el-card class="box-card">
      <div slot="header">
        <span class="header-text">查询结果</span>
      </div>
      <div class="content">

        <el-tabs v-model="cardResultActive" type="card">
          <el-tab-pane name="valid">
            <span slot="label">有效卡密 ({{validNum}})</span>
            <el-table
              max-height="300"
              :data="valid_cardList"
              border
              style="width: 100%">
              <el-table-column
                prop="card"
                label="卡号"
                width="150">
              </el-table-column>
              <el-table-column
                prop="valid_days"
                label="有效期">
              </el-table-column>
              <el-table-column prop="used_status" label="是否使用">
                <template slot-scope='scope'>
                  <span>{{scope.row.used_status|yesNo}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="usedByStudent"
                label="被学生充值"
                width="100">
                <template slot-scope='scope'>
                  <span>{{scope.row.usedByStudent|yesNo}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="free_stats"
                label="礼品免费卡"
                width="100">
                 <template slot-scope='scope'>
                   <span>{{scope.row.free_stats|yesNo}}</span>
                 </template>
              </el-table-column>
              <el-table-column
                prop="voip_stats"
                label="卡类型"
                width="120">
              </el-table-column>
              <el-table-column
                prop="user_id"
                label="用户ID"
                width="120">
              </el-table-column>
              <el-table-column
                prop="user_name"
                label="用户名"
                width="80">
              </el-table-column>
              <el-table-column
                prop="nick"
                label="昵称"
                width="120">
              </el-table-column>
              <el-table-column
                prop="packages_info"
                label="购买课程"
                width="180">
              </el-table-column>
              <el-table-column
                prop="create_day"
                label="订购时间"
                width="180">
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane name="delete">
            <span slot="label">卡密已删出 ({{deleteNum}})</span>
            <el-table
              :data="delete_cardList"
              border
              style="width: 100%">
              <el-table-column
                prop="card"
                label="卡号">
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane name="wrong">
            <span slot="label">卡密不存在 ({{wrongNum}})</span>
            <el-table
              :data="wrong_cardList"
              border
              style="width: 100%">
              <el-table-column
                prop="card"
                label="卡号">
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
  </section>
</div>
</template>

<script>
import IEcharts from 'vue-echarts-v3/src/full'
import {checkCard} from 'api/card-course-search'
export default {
  data () {
    return {
      // condition
      cards: '',
      // dialog
      dialogTableVisible: false,
      // pagination
      page: 1,
      total: 0,
      pageSize: 10,
      // tabs
      cardResultActive: 'valid',
      // business
      validNum: 0,
      deleteNum: 0,
      wrongNum: 0,
      valid_cardList: [],
      wrong_cardList: [],
      delete_cardList: []
    }
  },
  components: {
    IEcharts
  },
  mounted () {
    this.query()
  },
  filters: {
    yesNo (key) {
      switch (key) {
        case 'true':
          return '是'
        case 'false':
          return '否'
      }
    }
  },
  methods: {
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.page = val
      this.query()
    },
    query () {
      checkCard({cards: this.cards})
      .then((res) => {
        this.valid_cardList = res.valid_cards
        this.wrong_cardList = this._addCardKey(res.wrong_cards)
        this.delete_cardList = this._addCardKey(res.delete_cards)
        this.validNum = res.valid_cards.length
        this.deleteNum = res.delete_cards.length
        this.wrongNum = res.wrong_cards.length
        this._setCardResultActive()
      })
      .catch(msg => {
        this.$message.error(msg)
        this.valid_cardList = []
        this.wrong_cardList = []
        this.delete_cardList = []
        this.validNum = 0
        this.deleteNum = 0
        this.wrongNum = 0
      })
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex in [0, 1]) {
        if (row.multiFirst) {
          return {
            rowspan: row.multiTotal,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    _addCardKey (list) {
      let arr = []
      list.forEach(t => {
        arr.push({'card': t})
      })
      return arr
    },
    _setCardResultActive () {
      if (this.validNum > 0) {
        this.cardResultActive = 'valid'
      } else if (this.deleteNum > 0) {
        this.cardResultActive = 'delete'
      } else if (this.wrongNum > 0) {
        this.cardResultActive = 'wrong'
      } else {
        this.$message.error('所有输入卡密都不存在！')
      }
    }
  }
}
</script>


<style lang="stylus" scoped>
  @import '~common/stylus/base'
</style>



// WEBPACK FOOTER //
// src/components/card-course-search/card-search.vue